import React, { FC } from 'react'
import { UITypes } from 'LibNeo'
import { modalsSlice, ModalFeedback } from 'Modules'
import { FrontUrls } from 'Constants/FrontUrls'
import { useAppDispatch } from 'Src/hooks'
import { MODAL_NAME } from 'Constants/ModalName'
import {
	AdviceContainer,
	AdviceText,
	AdviceTextContainer,
	Container,
	ErrorCode,
	ErrorCodeText,
	ErrorContainer,
	ErrorTitle,
	InfoContainer,
	Support,
	TextContainer,
	Ups,
} from './styled'

export type ErrorPageProps = {
	title: string
	errorCode: number
	advice: string
}
const actions = {
	showModal: modalsSlice.actions.showModal,
}

export const ErrorPage: FC<ErrorPageProps> = (props) => {
	const { title, errorCode, advice } = props
	const { showModal } = useAppDispatch(actions)

	const openModalSupportModal = () =>
		showModal({ Component: ModalFeedback, key: MODAL_NAME.FEEDBACK })

	return (
		<>
			<ErrorContainer>
				<Container>
					<InfoContainer>
						<TextContainer>
							<ErrorCode>
								<ErrorCodeText>КОД ОШИБКИ: {errorCode}</ErrorCodeText>
							</ErrorCode>
							<Ups>Упс!</Ups>
							<ErrorTitle>{title}</ErrorTitle>
						</TextContainer>
						<AdviceContainer>
							<AdviceTextContainer>
								<AdviceText>{advice}</AdviceText>
							</AdviceTextContainer>
						</AdviceContainer>
						<div>
							<Support url={FrontUrls.dashboard} title="Стартовая страница" />
							<Support
								onClick={openModalSupportModal}
								type={UITypes.PASSIVE}
								iconName="support"
								title="Поддержка"
							/>
						</div>
					</InfoContainer>
					<div>
						<img src="/img/group.svg" alt="Error" />
					</div>
				</Container>
			</ErrorContainer>
		</>
	)
}
